<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <div class="l-page__header c-page__header">
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        维保签到信息
      </h2>
      <div class="c-page__header-btns">
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        />
      </div>
    </div>

    <div class="l-page__item l-page--search__item">
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="80px"
          label-suffix="："
        >
          <el-row class="c-form__row">
            <el-col
              :span="6"
              class="c-form__col"
            >
              <el-form-item
                label="项目名称"
                prop="xmmc"
                class="c-form__item"
              >
                <el-input
                  v-model.trim="filterParams.xmmc"
                  class="c-form__input"
                  clearable
                  maxlength="100"
                  placeholder="项目名称"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="6"
              class="c-form__col"
            >
              <el-form-item
                label="计划名称"
                prop="jhmc"
                class="c-form__item"
              >
                <el-input
                  v-model.trim="filterParams.jhmc"
                  class="c-form__input"
                  clearable
                  maxlength="100"
                  placeholder="计划名称"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="6"
              class="c-form__col"
            >
              <el-form-item
                label="签到人员"
                prop="qdrDm"
                class="c-form__item"
              >
                <el-input
                  v-model.trim="filterParams.qdrDm"
                  class="c-form__input"
                  clearable
                  maxlength="50"
                  placeholder="签到人员"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="6"
              class="c-form__col"
            >
              <el-form-item
                label="签到月份"
                prop="tjyf"
                class="c-form__item"
              >
                <el-date-picker
                  v-model="filterParams.tjyf"
                  type="month"
                  value-format="timestamp"
                  placeholder="选择月份"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>

    <div class="l-page__body l-page--search__body">
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane label="查询结果">
          <k-table
            ref="signTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { signService } from './sign.service.js';

export default {
  name: 'JxxfWbSignList',
  data () {
    return {
      loading: false,
      filterParams: {
        xmmc: null,
        jhmc: null,
        qdrDm: null,
        tjyf: new Date().getTime()
      },
      trueFilterParams: {},
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'xmmc', label: '项目名称', align: 'left', minWidth: '180', type: 'text' },
        { key: 'jhmc', label: '计划名称', align: 'left', minWidth: '160', type: 'text' },
        { key: 'xmdz', label: '项目地址', align: 'left', minWidth: '180', type: 'text' },
        { key: 'qdrMc', label: '签到人员', align: 'left', width: '110', type: 'text' },
        { key: 'qdsj', label: '签到时间', align: 'center', width: '150', type: 'dateTime' },
        { key: 'gpsX', label: 'GPS-X坐标', align: 'left', width: '130', type: 'text' },
        { key: 'gpsY', label: 'GPS-Y坐标', align: 'left', width: '130', type: 'text' },
        { key: 'jl', label: '签到距离（米）', align: 'right', width: '120', type: 'text' },
        { key: 'sjlx', label: '手机类型', align: 'left', width: '100', type: 'text' },
        { key: 'qdztMc', label: '签到状态', align: 'center', width: '100', type: 'text' },
        { key: 'qddz', label: '签到地址', align: 'left', minWidth: '180', type: 'text' }
      ]
    };
  },
  methods: {
    /** 记录当前查询条件并刷新列表。 */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search();
    },
    /** 分页查询江西维保签到信息。 */
    search (pageNo = 1) {
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = pageNo;
      this.loading = true;
      signService.page(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);
        })
        .catch(err => {
          console.error('查询江西维保签到信息失败', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /** 修改分页大小并重新查询。 */
    handleSizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.search();
    },
    /** 重置查询条件。 */
    resetForm () {
      this.$refs.filterParams.resetFields();
      this.refreshSearch();
    }
  },
  created () {
    this.refreshSearch();
  }
};
</script>
